import { render, staticRenderFns } from "./CommentFormNotLoggedin.vue?vue&type=template&id=6c5c3850&scoped=true&"
import script from "./CommentFormNotLoggedin.vue?vue&type=script&lang=js&"
export * from "./CommentFormNotLoggedin.vue?vue&type=script&lang=js&"
import style0 from "./CommentFormNotLoggedin.vue?vue&type=style&index=0&id=6c5c3850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c3850",
  null
  
)

export default component.exports